import React, { useState } from 'react';
import { useTranslatedText } from '../i18n/useTranslatedText.js';
import './FilterSection.css';

const FilterSection = ({ onFilter }) => {
  const [location, setLocation] = useState('');
  const [date, setDate] = useState('');
  const [organizer, setOrganizer] = useState('');
  const [minCapacity, setMinCapacity] = useState('');
  const [ageRangeFilter, setAgeRangeFilter] = useState('');

  const titleText = useTranslatedText('Gelecek Etkinlikler');
  const locationPlaceholder = useTranslatedText('Konum Giriniz');
  const organizerPlaceholder = useTranslatedText('Organizatör Giriniz');
  const minCapPlaceholder = useTranslatedText('Minimum Kapasite');
  const ageRangePlaceholder = useTranslatedText('Yaş Aralığı Seçiniz');
  const allAgesText = useTranslatedText('Her Yaş');
  const filterText = useTranslatedText('Filtrele');

  const handleFilterChange = () => {
    onFilter({
      location: location || '',
      date: date || '',
      organizer: organizer || '',
      minCapacity: minCapacity || '',
      ageRangeFilter: ageRangeFilter || '',
    });
  };

  return (
    <div className="filter-section">
      <div className="title">
        <h1>{titleText}</h1>
      </div>

      <div className="filters">
        <div className="filter-location">
          <input
            className="locinp"
            type="text"
            placeholder={locationPlaceholder}
            value={location}
            onChange={(e) => setLocation(e.target.value)}
            aria-label="Location filter"
          />
        </div>

        <div className="filter-date">
          <input className="dateinp" type="date" value={date} onChange={(e) => setDate(e.target.value)} aria-label="Date filter" />
        </div>

        <div className="filter-organizer">
          <input
            className="orginp"
            type="text"
            placeholder={organizerPlaceholder}
            value={organizer}
            onChange={(e) => setOrganizer(e.target.value)}
            aria-label="Organizer filter"
          />
        </div>

        <label>
          <input
            type="number"
            value={minCapacity}
            onChange={(e) => setMinCapacity(e.target.value)}
            placeholder={minCapPlaceholder}
          />
        </label>

        <label>
          <select value={ageRangeFilter} onChange={(e) => setAgeRangeFilter(e.target.value)}>
            <option value="">{ageRangePlaceholder}</option>
            <option value="all">{allAgesText}</option>
            <option value="0-12">0-12</option>
            <option value="13-17">13-17</option>
            <option value="18+">18+</option>
            <option value="21+">21+</option>
          </select>
        </label>

        <button className="filter-button" onClick={handleFilterChange}>
          {filterText}
        </button>
      </div>
    </div>
  );
};

export default FilterSection;

